export class AddOnDTO {
    type!: string;
    currency!: string;
    additionalWarehouseDescription?: string;
    additionalWarehousePrice?: string;
    additionalUserDescription?: string;
    additionalUserPrice?: string;
    includedUsersPerWarehouse?: number;
    additionalServiceTruckDescription?: string;
    additionalServiceTruckPrice?: number;

    constructor(data: AddOnDTO) {
        this.type = data.type;
        this.currency = data.currency
        if (data.additionalUserDescription) this.additionalUserDescription = data.additionalUserDescription;
        if (data.additionalUserPrice) this.additionalUserPrice = data.additionalUserPrice;
        if (data.additionalWarehouseDescription) this.additionalWarehouseDescription = data.additionalWarehouseDescription;
        if (data.additionalWarehousePrice) this.additionalWarehousePrice = data.additionalWarehousePrice;
        if (data.includedUsersPerWarehouse) this.includedUsersPerWarehouse = data.includedUsersPerWarehouse;
        if (data.additionalServiceTruckDescription) this.additionalServiceTruckDescription = data.additionalServiceTruckDescription;
        if (data.additionalServiceTruckPrice) this.additionalServiceTruckPrice = data.additionalServiceTruckPrice;
    }
}